import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../api/axios";
import { useAuth } from "../context/AuthContext";
import Logo from "../components/Logo";

export default function AdminRegister() {
  const [form, setForm] = useState({ name:"", email:"", password:"", adminCode:"" });
  const [errs, setErrs] = useState({});
  const [loading, setLoading] = useState(false);
  const { adminLogin } = useAuth();
  const nav = useNavigate();

  const validate = () => {
    const e = {};
    if (!form.name.trim())      e.name      = "Name is required";
    if (!form.email.trim())     e.email     = "Email is required";
    if (
      form.password.length < 12 ||
      !/[A-Z]/.test(form.password) ||
      !/[0-9]/.test(form.password) ||
      !/[!@#$%^&*]/.test(form.password)
    ) e.password = "Password must be 12+ characters with uppercase, number, and special character (!@#$%^&*)";
    if (!form.adminCode.trim()) e.adminCode = "Secret code is required";
    return e;
  };

  const submit = async e => {
    e.preventDefault();
    const e2 = validate();
    if (Object.keys(e2).length) { setErrs(e2); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { ...form, role:"admin" });
      adminLogin(data.token, data.user);
      nav("/admin");
    } catch (err) {
      setErrs({ adminCode: err.response?.data?.message || "Registration failed" });
    }
    setLoading(false);
  };

  const inp = k => ({
    width:"100%", marginTop:6, padding:"12px 14px", borderRadius:10,
    border:"1px solid " + (errs[k] ? "#ef4444" : "#1e293b"),
    background:"#0d0d0d", color:"#f1f5f9", fontSize:14,
    outline:"none", boxSizing:"border-box"
  });

  return (
    <div style={{ minHeight:"100vh", background:"#0a0a0a", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24 }}>

      {/* Back button */}
      <div style={{ width:"100%", maxWidth:400, marginBottom:16 }}>
        <button
          onClick={() => nav(-1)}
          style={{ background:"transparent", border:"1px solid #1e293b", color:"#64748b", padding:"7px 16px", borderRadius:20, fontSize:13, cursor:"pointer", display:"inline-flex", alignItems:"center", gap:6 }}
        >
          ← Back
        </button>
      </div>

      <div style={{ background:"#111111", borderRadius:16, border:"1px solid #1e293b", padding:"36px 28px", width:"100%", maxWidth:400 }}>

        <div style={{ textAlign:"center", marginBottom:24 }}>
          <div style={{ display:"flex", justifyContent:"center", marginBottom:8 }}>
            <Logo size={28} />
          </div>
          <div style={{ fontSize:16, fontWeight:700, color:"#f1f5f9", marginBottom:4 }}>Admin Setup</div>
          <div style={{ fontSize:13, color:"#475569" }}>Create the platform administrator account</div>
        </div>

        <div style={{ background:"#f9731610", border:"1px solid #f9731630", borderRadius:8, padding:"10px 14px", marginBottom:20, fontSize:12, color:"#f97316" }}>
          ⚠️ Platform owners only. You need the admin secret code to proceed.
        </div>

        <form onSubmit={submit}>
          <div style={{ marginBottom:14 }}>
            <label style={{ fontSize:13, color:"#64748b", fontWeight:500 }}>Full Name *</label>
            <input style={inp("name")} value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="Admin Name" />
            {errs.name && <div style={{ color:"#ef4444", fontSize:11, marginTop:4 }}>{errs.name}</div>}
          </div>

          <div style={{ marginBottom:14 }}>
            <label style={{ fontSize:13, color:"#64748b", fontWeight:500 }}>Admin Email *</label>
            <input type="email" style={inp("email")} value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} placeholder="admin@padhaipass.com" />
            {errs.email && <div style={{ color:"#ef4444", fontSize:11, marginTop:4 }}>{errs.email}</div>}
          </div>

          <div style={{ marginBottom:14 }}>
            <label style={{ fontSize:13, color:"#64748b", fontWeight:500 }}>Password *</label>
            <input type="password" style={inp("password")} value={form.password} onChange={e=>setForm(f=>({...f,password:e.target.value}))} placeholder="12+ chars, uppercase, number, special (!@#$%^&*)" />
            {errs.password && <div style={{ color:"#ef4444", fontSize:11, marginTop:4 }}>{errs.password}</div>}
          </div>

          <div style={{ marginBottom:22 }}>
            <label style={{ fontSize:13, color:"#64748b", fontWeight:500 }}>Secret Code *</label>
            <input type="password" style={inp("adminCode")} value={form.adminCode} onChange={e=>setForm(f=>({...f,adminCode:e.target.value}))} placeholder="Enter admin secret code" />
            {errs.adminCode && <div style={{ color:"#ef4444", fontSize:11, marginTop:4 }}>{errs.adminCode}</div>}
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{ width:"100%", padding:13, background:"#f97316", color:"#fff", border:"none", borderRadius:10, fontSize:15, fontWeight:700, cursor:"pointer" }}
          >
            {loading ? "Creating..." : "Create Admin Account →"}
          </button>
        </form>

        <p style={{ textAlign:"center", marginTop:16, fontSize:13, color:"#475569" }}>
          <Link to="/admin-login" style={{ color:"#f97316", fontWeight:600, textDecoration:"none" }}>← Back to Admin Login</Link>
        </p>
      </div>
    </div>
  );
}